var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.001,
    height: 28.001,
    viewBox: "0 0 28.001 28.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4641",
    "data-name": "Group 4641",
    transform: "translate(-1629.539 -293.156)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    transform: "translate(1629.539 293.156)",
    fill: "#0a7da7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M32.513,21.385a7.726,7.726,0,0,1-1.752.486c.28-.035.7-.555.876-.764a3.839,3.839,0,0,0,.6-1.041c0-.035.035-.069,0-.1h-.105a10.608,10.608,0,0,1-2.067.8c-.07,0-.105,0-.14-.035-.07-.069-.105-.139-.175-.174a4.966,4.966,0,0,0-1.016-.625,3.355,3.355,0,0,0-1.542-.243,3.781,3.781,0,0,0-2.663,1.388,3.266,3.266,0,0,0-.7,1.388,4.253,4.253,0,0,0-.035,1.492c0,.069,0,.1-.07.069a11.068,11.068,0,0,1-7.148-3.575q-.105-.156-.21,0a3.552,3.552,0,0,0,.631,4.234,2.407,2.407,0,0,0,.456.382,3.836,3.836,0,0,1-1.367-.382c-.07-.069-.14-.035-.14.069a1.817,1.817,0,0,0,.035.416,3.68,3.68,0,0,0,2.243,2.88,2.283,2.283,0,0,0,.456.139,3.793,3.793,0,0,1-1.367.035c-.105-.035-.14.035-.105.139a3.857,3.857,0,0,0,2.838,2.36c.14.035.245.035.385.069l-.035.035c-.315.486-1.437.833-1.927,1.006a7.112,7.112,0,0,1-2.943.382c-.175-.035-.175-.035-.245,0-.035.035,0,.069.035.1.21.139.42.243.6.347a8.5,8.5,0,0,0,1.962.764,10.528,10.528,0,0,0,10.162-2.36,10.436,10.436,0,0,0,2.8-7.7c0-.1.14-.174.21-.243A7.522,7.522,0,0,0,32.408,21.7a.32.32,0,0,0,.07-.278h0C32.583,21.35,32.583,21.35,32.513,21.385Z",
    transform: "translate(1619.576 281.4)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f6320373c69937ef9a18b90971452aac.svg";
export { ForwardRef as ReactComponent };